import React from 'react'
import { useStyles } from './NumeroOublieStyle'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { useForm } from 'react-hook-form'

//Material UI Imports
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { FormControl } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import { useSnackbar } from 'notistack'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import IconButton from '@material-ui/core/IconButton'

//Redux
import allActions from '../../redux/actions/user'


export default function NewPassword(props) {

  const dispatch = useDispatch()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const { register, handleSubmit } = useForm()

  async function requestNumero(data) {
    
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!data.email.match(regex)) return enqueueSnackbar(`Erreur: L'email n'est pas valide`, { variant: `error` })

    const { res, json } = await allActions.fetchPostAPI('api/users/request-numero', data, dispatch)
    if (res.err) return enqueueSnackbar(`Erreur: ${res.err}`, { variant: `error` })
    if (json.err) return enqueueSnackbar(`Erreur: ${json.err}`, { variant: `error` })

    enqueueSnackbar(json.message, { variant: `success` })

    history.push('/login')
  }

  return (
    <div className={classes.root}>
      <Card className={classes.card} >
        <CardContent>
          <Typography variant="h5" component="h2" className={classes.title}>
            <IconButton onClick={() => history.push('/')} style={{ marginRight: 8 }}>
              <ArrowBackIcon />
            </IconButton>
            Récupérer votre numéro d'abonné
          </Typography>
          <form onSubmit={handleSubmit(requestNumero)}>
            <FormControl fullWidth={true}>
              <TextField
                label="Nom"
                name="nom"
                margin="dense"
                variant="outlined"
                fullWidth={true}
                required
                inputRef={register()}
              />

              <TextField
                label="Prenom"
                name="prenom"
                margin="dense"
                variant="outlined"
                fullWidth={true}
                required
                inputRef={register()}
              />

              <TextField
                label="Email"
                name="email"
                margin="dense"
                variant="outlined"
                fullWidth={true}
                required
                inputRef={register()}
              />

              <Button
                className={classes.button}
                fullWidth
                color="primary"
                variant="contained"
                type="submit"
                disableElevation
              >Récupérer</Button>

            </FormControl>

          </form>
        </CardContent>
      </Card>
    </div >
  )
}
